(() => {
  if (window.__ctPacksBooted) return;
window.__ctPacksBooted = true;
  console.log('[CT PACKS] ct-packs.js cargado', new Date().toISOString());

  const SELECTOR_PACK = '[data-ct-pack]';
  const SELECTOR_ALL_GRID_FORMS = 'product-form[data-ct-is-all-grid="true"]';
  const SELECTOR_PDP_FORMS = 'product-form[data-ct-is-pdp="true"]';

async function fetchCart() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  if (!res.ok) throw new Error('No se pudo leer /cart.js');
  return res.json();
}

function buildQtyMap(cart) {
  const map = new Map();

  (cart?.items || []).forEach((it) => {
    const vid = Number(it.variant_id || it.id || 0);
    if (vid <= 0) return;

    const isBundleLine = !!(it.properties && it.properties._ct_bundle_id);
    if (isBundleLine) return;

    const isCtExtraLine = !!(it.properties && it.properties._ct_extra_item);

    // Preferimos la línea CT extra si existe.
    if (!map.has(vid) || isCtExtraLine) {
      map.set(vid, {
        qty: Number(it.quantity || 0),
        key: String(it.key || '')
      });
    }
  });

  return map;
}

function getQtyFromMap(map, variantId) {
  const entry = map.get(Number(variantId));
  return entry ? Number(entry.qty || 0) : 0;
}

function getLineKeyFromMap(map, variantId) {
  const entry = map.get(Number(variantId));
  return entry ? String(entry.key || '') : '';
}
function getBaseInventoryForNodes(nodes) {
  if (!nodes) return 0;

  const productFormEl =
    nodes.form?.closest('product-form') ||
    nodes.atcWrap?.closest('product-form') ||
    nodes.stepperWrap?.closest('product-form') ||
    null;

  const raw =
    productFormEl?.getAttribute('data-ct-inventory-qty') ||
    productFormEl?.dataset?.ctInventoryQty ||
    '';

  const qty = Number(raw);
  return Number.isFinite(qty) && qty >= 0 ? qty : 0;
}

function getReservedQtyByVariant(cart, variantId, options = {}) {
  const vid = Number(variantId);
  const includeBundleLines = options.includeBundleLines !== false;

  if (!Number.isFinite(vid) || vid <= 0) return 0;

  let total = 0;

  (cart?.items || []).forEach((it) => {
    const itemVid = Number(it.variant_id || it.id || 0);
    if (itemVid !== vid) return;

    const isBundleLine = !!(it.properties && it.properties._ct_bundle_id);

    if (!includeBundleLines && isBundleLine) return;

    total += Number(it.quantity || 0);
  });

  return total;
}

async function getAvailableStockForVariant(nodes) {
  if (!nodes || !nodes.variantId) return 0;

  const baseInventory = getBaseInventoryForNodes(nodes);

  // Si no tenemos inventario base renderizado, no bloqueamos desde front.
  if (!Number.isFinite(baseInventory) || baseInventory <= 0) {
    return 9999;
  }

  const cart = await fetchCart();
  const reservedQty = getReservedQtyByVariant(cart, nodes.variantId, {
    includeBundleLines: true
  });

  return Math.max(0, baseInventory - reservedQty);
}
async function getMaxAllowedQtyForVariant(nodes) {
  if (!nodes || !nodes.variantId) return 0;

  const baseInventory = getBaseInventoryForNodes(nodes);

  // Si no tenemos inventario base renderizado, no bloqueamos desde front.
  if (!Number.isFinite(baseInventory) || baseInventory <= 0) {
    return 9999;
  }

  const cart = await fetchCart();
  const qtyMap = buildQtyMap(cart);
  const ownQty = getQtyFromMap(qtyMap, nodes.variantId);

  const reservedQty = getReservedQtyByVariant(cart, nodes.variantId, {
    includeBundleLines: true
  });

  const remainingQty = Math.max(0, baseInventory - reservedQty);

  // Máximo editable real = lo que ya tiene esta línea normal + lo que sigue libre
  return Math.max(0, ownQty + remainingQty);
}

function updateStepperLimitState(nodes, qty, maxQty) {
  if (!nodes?.stepperWrap) return;

  const currentQty = Math.max(0, Number(qty || 0));
  const limitQty = Number(maxQty);

  if (Number.isFinite(limitQty) && limitQty >= 0) {
    nodes.stepperWrap.dataset.ctMaxQty = String(limitQty);
  } else {
    delete nodes.stepperWrap.dataset.ctMaxQty;
  }

  if (nodes.btnPlus) {
    const disablePlus =
      Number.isFinite(limitQty) &&
      limitQty >= 0 &&
      currentQty >= limitQty;

    nodes.btnPlus.disabled = disablePlus;
    if (disablePlus) {
      nodes.btnPlus.setAttribute('aria-disabled', 'true');
    } else {
      nodes.btnPlus.removeAttribute('aria-disabled');
    }
  }

  if (nodes.btnMinus) {
    const disableMinus = currentQty <= 0;
    nodes.btnMinus.disabled = disableMinus;
    if (disableMinus) {
      nodes.btnMinus.setAttribute('aria-disabled', 'true');
    } else {
      nodes.btnMinus.removeAttribute('aria-disabled');
    }
  }
}
function clampQtyToAvailableStock(targetQty, availableQty) {
  const qty = Number(targetQty || 0);
  const stock = Number(availableQty || 0);

  if (!Number.isFinite(qty) || qty <= 0) return 0;
  if (!Number.isFinite(stock) || stock <= 0) return 0;

  return Math.max(0, Math.min(qty, stock));
}
function showStockAdjustedMessage(nodes, requestedQty, appliedQty, options = {}) {
  if (Number(requestedQty) <= Number(appliedQty)) return;

  const context = String(options.context || '');
  const applied = Number(appliedQty || 0);
  const requested = Number(requestedQty || 0);

  let message = 'Cantidad ajustada por disponibilidad.';

  if (applied <= 0) {
    message = 'Sin stock disponible.';
  } else if (context === 'add' || context === 'apply-pack') {
    message = `Se agregaron ${applied} pares por disponibilidad.`;
  } else if (context === 'typing') {
    message = 'Cantidad ajustada por disponibilidad.';
  } else if (context === 'stepper-max') {
    message = 'Inventario máximo disponible.';
  } else if (requested > applied) {
    message = 'Cantidad ajustada por disponibilidad.';
  }

  console.warn('[CT PACKS]', message, {
    requestedQty,
    appliedQty,
    context
  });

  showCardMessage(nodes, message, { type: 'error', autoHideMs: 5000 });
}
function getCardMessageNode(nodes) {
  return (
    nodes.form?.closest('product-form')?.querySelector('.js-form-error') ||
    nodes.atcWrap?.closest('product-form')?.querySelector('.js-form-error') ||
    nodes.stepperWrap?.closest('product-form')?.querySelector('.js-form-error') ||
    null
  );
}
function getProductTitleForMessage(nodes) {
  const card =
    nodes?.form?.closest('product-card') ||
    nodes?.atcWrap?.closest('product-card') ||
    nodes?.stepperWrap?.closest('product-card') ||
    null;

  const titleEl =
    card?.querySelector('.card__title a') ||
    card?.querySelector('.card__title') ||
    null;

  return String(titleEl?.textContent || '').trim();
}

function clearCardMessageTimer(nodes) {
  const errorBox = getCardMessageNode(nodes);
  if (!errorBox) return;

  const timerId = Number(errorBox.dataset.ctMessageTimer || 0);
  if (timerId) {
    window.clearTimeout(timerId);
  }
  delete errorBox.dataset.ctMessageTimer;
}
function showCardMessage(nodes, message, options = {}) {
  const errorBox = getCardMessageNode(nodes);
  if (!errorBox) return;

  const type = String(options.type || 'error');
  const autoHideMs = Number(options.autoHideMs || 0);

  clearCardMessageTimer(nodes);

  errorBox.textContent = message || '';
  errorBox.hidden = !message;

  errorBox.dataset.ctMessageType = type;

  if (message && autoHideMs > 0) {
    const timerId = window.setTimeout(() => {
      clearCardMessage(nodes);
    }, autoHideMs);

    errorBox.dataset.ctMessageTimer = String(timerId);
  }
}

function clearCardMessage(nodes) {
  const errorBox = getCardMessageNode(nodes);
  if (!errorBox) return;

  clearCardMessageTimer(nodes);

  errorBox.textContent = '';
  errorBox.hidden = true;
  delete errorBox.dataset.ctMessageType;
}
function findCardNodes(productFormEl) {
  const form = productFormEl.querySelector('form');
  const atcWrap = productFormEl.querySelector('[data-ct-atc-wrap]');
  const stepperWrap = productFormEl.querySelector('[data-ct-stepper-wrap]');
  const qtyEl = productFormEl.querySelector('[data-ct-stepper-qty]');
  const btnPlus = productFormEl.querySelector('[data-ct-stepper-plus]');
  const btnMinus = productFormEl.querySelector('[data-ct-stepper-minus]');
  const applyBtn = productFormEl.querySelector('[data-ct-pack-apply]');
  const packRoot = productFormEl.querySelector('[data-ct-pack]');
  const packSelect = packRoot?.querySelector('[data-ct-pack-select]') || null;

  const idFromForm = form?.querySelector('input[name="id"]')?.value;

// dataset a veces falla (especialmente en custom elements). Usamos getAttribute directo:
const idFromAttr =
  productFormEl.getAttribute('data-ct-variant-id') ||
  productFormEl.getAttribute('data-variant-id');

const variantId = Number(idFromAttr || idFromForm || 0);
  const qtyInput = form?.querySelector('input[name="quantity"]') || null;

  return {
    form,
    variantId,
    productId: Number(productFormEl.getAttribute('data-ct-product-id') || 0),
    qtyInput,
    atcWrap,
    stepperWrap,
    qtyEl,
    btnPlus,
    btnMinus,
    applyBtn,
    packRoot,
    packSelect
  };
}
// ===== Helpers para qtyEl (puede ser <span> o <input>) =====
function readQtyEl(el) {
  if (!el) return 0;
  if (el.tagName === 'INPUT') return Number(el.value || 0);
  return Number(el.textContent || 0);
}

function writeQtyEl(el, qty) {
  if (!el) return;
  const q = String(Number(qty || 0));
  if (el.tagName === 'INPUT') el.value = q;
  else el.textContent = q;
}

function setStepperUI(nodes, qty) {
  if (!nodes.atcWrap || !nodes.stepperWrap || !nodes.qtyEl) return;

  const safeQty = Math.max(0, Number(qty || 0));
  const stepperEl = nodes.stepperWrap.querySelector('[data-ct-stepper]');

  if (safeQty > 0) {
    nodes.atcWrap.hidden = true;
    nodes.stepperWrap.hidden = false;
    writeQtyEl(nodes.qtyEl, safeQty);
    stepperEl?.setAttribute('data-ct-qty', String(safeQty));
  } else {
    nodes.stepperWrap.hidden = true;
    nodes.atcWrap.hidden = false;
    writeQtyEl(nodes.qtyEl, 0);
    stepperEl?.setAttribute('data-ct-qty', '0');
    if (nodes.applyBtn) nodes.applyBtn.hidden = true;
  }

  const storedMaxAttr = nodes.stepperWrap.dataset.ctMaxQty;
const storedMaxQty =
  storedMaxAttr !== undefined && storedMaxAttr !== ''
    ? Number(storedMaxAttr)
    : Infinity;

updateStepperLimitState(nodes, safeQty, storedMaxQty);
}

function getPackIdxForQty(packs, qty) {
  if (!Array.isArray(packs) || packs.length === 0) return 0;
  let idx = 0;

  // match exacto
  const exact = packs.findIndex(p => Number(p.qty) === Number(qty));
  if (exact >= 0) return exact;

  // pack mayor cuyo qty <= qty
  for (let i = 0; i < packs.length; i++) {
    if (Number(packs[i].qty) <= Number(qty)) idx = i;
  }
  return idx;
}

function setActiveTab(root, packQty) {
  const tabs = root.querySelectorAll('.ct-pack__tab');
  if (!tabs.length) return;

  tabs.forEach((t) => {
    const tabQty = Number(t.dataset.ctPackTab || 0);
    const isSelected = tabQty === Number(packQty);
    t.setAttribute('aria-selected', isSelected ? 'true' : 'false');
  });
}

function updateMetaForQty(root, qty) {
  if (!root) return;
  const packs = root.__ctPacks;
  const basePriceCents = Number(root.__ctBasePriceCents || root.dataset.ctBasePrice || 0);
  if (!Array.isArray(packs) || packs.length === 0) return;
  if (!Number.isFinite(basePriceCents) || basePriceCents <= 0) return;

  const idx = getPackIdxForQty(packs, qty);
  const pack = packs[idx] || packs[0];

  // “Pack virtual”: usa el descuento del pack aplicable, pero con qty real
  const virtualPack = { qty: Number(qty), discount: Number(pack.discount || 0) };

  updateMetaUI(root, virtualPack, basePriceCents);
}
function updateCardUnitPrice(nodes, qty) {
  // El slot está en el card (no dentro del product-form)
    const scope =
    nodes?.form?.closest('product-card') ||
    nodes?.atcWrap?.closest('product-card') ||
    nodes?.stepperWrap?.closest('product-card') ||
    nodes?.form?.closest('.shopify-section') || // PDP fallback
    document;

  const unitEl = scope.querySelector('[data-ct-card-unit-price]');
  if (!unitEl || !nodes?.packRoot) return;

  const packs = nodes.packRoot.__ctPacks || [];
  const basePriceCents = Number(nodes.packRoot.__ctBasePriceCents || nodes.packRoot.dataset.ctBasePrice || 0);
  if (!Array.isArray(packs) || packs.length === 0) return;
  if (!Number.isFinite(basePriceCents) || basePriceCents <= 0) return;

  const moneyFormat = nodes.packRoot.dataset.ctMoneyFormat || '{{amount}}';
  const q = Number(qty || 0);
  if (!Number.isFinite(q) || q <= 0) {
    unitEl.hidden = true;
    return;
  }

  const idx = getPackIdxForQty(packs, q);
  const pack = packs[idx] || packs[0];

  const pricing = computePricing(basePriceCents, q, Number(pack.discount || 0));
  const unitMoney = moneyFromCents(pricing.unit, moneyFormat);

  unitEl.textContent = unitMoney;
  unitEl.hidden = false;
}
function updateCardStrikePrice(nodes, qty) {
  const scope =
    nodes?.form?.closest('product-card') ||
    nodes?.atcWrap?.closest('product-card') ||
    nodes?.stepperWrap?.closest('product-card') ||
    nodes?.form?.closest('.shopify-section') ||
    document;

  const strikeEl = scope.querySelector('[data-ct-card-strike-price]');
  if (!strikeEl || !nodes?.packRoot) return;

  const packs = nodes.packRoot.__ctPacks || [];
  const basePriceCents = Number(nodes.packRoot.__ctBasePriceCents || nodes.packRoot.dataset.ctBasePrice || 0);
  if (!Array.isArray(packs) || packs.length === 0) return;
  if (!Number.isFinite(basePriceCents) || basePriceCents <= 0) return;

  const moneyFormat = nodes.packRoot.dataset.ctMoneyFormat || '{{amount}}';
  const q = Number(qty || 0);

  if (!Number.isFinite(q) || q <= 0) {
    strikeEl.hidden = true;
    strikeEl.textContent = '';
    return;
  }

  const idx = getPackIdxForQty(packs, q);
  const pack = packs[idx] || packs[0];

  const targetUnitPriceCents = targetPriceToCents(pack.discount, basePriceCents);

  if (targetUnitPriceCents >= basePriceCents) {
    strikeEl.hidden = true;
    strikeEl.textContent = '';
    return;
  }

  const baseUnitMoney = moneyFromCents(basePriceCents, moneyFormat);

  strikeEl.textContent = baseUnitMoney;
  strikeEl.hidden = false;
}

function hideNativeCardPrice(nodes) {
  // ✅ Funciona en GRID (product-card) y en PDP (bloque de precio)
  const card =
    nodes?.form?.closest('product-card') ||
    nodes?.atcWrap?.closest('product-card') ||
    nodes?.stepperWrap?.closest('product-card');

  // Nuestro “unit” es el indicador de que ya pintamos promo
  let unitEl = null;
  let scope = null;

  if (card) {
    scope = card;
    unitEl = card.querySelector('[data-ct-card-unit-price]');
  } else {
  // PDP: el precio NO está dentro del product-form; está en el bloque "price" del mismo section.
  const section =
    nodes?.form?.closest('.shopify-section') ||
    nodes?.packRoot?.closest('.shopify-section') ||
    document;

  // Contenedor real del precio del PDP (donde vive el snippet render 'price')
  scope =
    section.querySelector('.product-info__price') ||
    section.querySelector('[data-dynamic-variant-content$="-price"]') ||
    section.querySelector('.product-price') ||
    section;

  // Nuestros slots CT están en el bloque price (no en el form), así que búscalos en ese scope
  unitEl = scope.querySelector('[data-ct-card-unit-price]');
}

  if (!scope || !unitEl || unitEl.hidden) return;

  // Candidatos típicos del snippet price
  const nativeCandidates = [
    '.price',
    '.price__regular',
    '.price__sale',
    '.price-item',
    '.price--top',
    '.price--bottom'
  ];

  nativeCandidates.forEach((sel) => {
    scope.querySelectorAll(sel).forEach((el) => {
      // no tocar nuestros slots
      if (el.closest?.('[data-ct-card-unit-price]')) return;
      if (el.closest?.('[data-ct-card-strike-price]')) return;
      el.style.display = 'none';
    });
  });
}

// Si qty coincide con pack exacto, sincroniza dropdown.
// Si qty supera el pack máximo, usa el pack más grande.
function syncPackToQty(nodes, qty) {
  if (!nodes.packRoot || !nodes.packSelect) return;
  const packs = nodes.packRoot.__ctPacks;
  if (!Array.isArray(packs) || packs.length === 0) return;

  let targetIdx = 0;
  const exactIdx = packs.findIndex(p => Number(p.qty) === Number(qty));

  if (exactIdx >= 0) {
    targetIdx = exactIdx;
  } else {
    // mayor pack cuyo qty <= qty (p.ej. qty=14 => pack 12)
    for (let i = 0; i < packs.length; i++) {
      if (Number(packs[i].qty) <= Number(qty)) targetIdx = i;
    }
  }

  // Si cambia por stepper y es match exacto o supera máximo, NO mostramos "Aplicar pack"
  nodes.packSelect.value = String(targetIdx);

// Actualiza tabs visuales sin disparar change
setActiveTab(nodes.packRoot, packs[targetIdx].qty);

// Actualiza Total/Ahorro/Unitario según qty real
updateMetaForQty(nodes.packRoot, qty);

// Apply pack no debe mostrarse cuando sincroniza el stepper
if (nodes.applyBtn) nodes.applyBtn.hidden = true;
}

// Se dispara cuando el usuario cambia el dropdown teniendo qty>0:
// mostramos "Aplicar pack" (no cambia carrito aún)
function wireApplyPackBehavior(nodes) {
  if (!nodes.packSelect || !nodes.applyBtn || !nodes.qtyEl || !nodes.packRoot) return;

  // Evita doble binding si Canopy re-renderiza
  if (nodes.packSelect.dataset.ctApplyBound === 'true') return;
  nodes.packSelect.dataset.ctApplyBound = 'true';

  nodes.packSelect.addEventListener('change', () => {
    const currentQty = readQtyEl(nodes.qtyEl);
    if (currentQty <= 0) {
      nodes.applyBtn.hidden = true;
      return;
    }

    const packs = nodes.packRoot.__ctPacks || [];
    const currentIdx = getPackIdxForQty(packs, currentQty);
    const selectedIdx = Number(nodes.packSelect.value || 0);

    // Solo mostrar si realmente está eligiendo un pack distinto al que corresponde a la qty actual
    nodes.applyBtn.hidden = (selectedIdx === currentIdx);
  });
}

async function cartChange(variantId, newQty) {
  const vid = Number(variantId);
  const qty = Number(newQty);

  if (!Number.isFinite(vid) || vid <= 0) {
    throw new Error('variantId inválido en cartChange');
  }
  if (!Number.isFinite(qty) || qty < 0) {
    throw new Error('quantity inválida en cartChange');
  }

  const cart = await fetchCart();
  const qtyMap = buildQtyMap(cart);
  const lineKey = getLineKeyFromMap(qtyMap, vid);
  const currentQty = getQtyFromMap(qtyMap, vid);

  // Si no existe línea normal y quieren subir a > 0, crear línea nueva normal
  if (!lineKey) {
    if (qty <= 0) return cart;
    return await cartAdd(vid, qty);
  }

  // Si no cambia, devuelve carrito actual
  if (currentQty === qty) {
    return cart;
  }

  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      id: lineKey,
      quantity: qty
    })
  });

  if (!res.ok) throw new Error('No se pudo actualizar el carrito');
  return res.json();
}
async function cartAdd(variantId, qty) {
  const vid = Number(variantId);
  const q = Number(qty);

  if (!Number.isFinite(vid) || vid <= 0) throw new Error('variantId inválido en cartAdd');
  if (!Number.isFinite(q) || q <= 0) throw new Error('qty inválida en cartAdd');

  // Forzamos línea normal separada del bundle
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      items: [{
        id: vid,
        quantity: q,
        properties: {
          '_ct_extra_item': 'true'
        }
      }]
    })
  });

  if (!res.ok) throw new Error('No se pudo agregar al carrito');
  return await fetchCart();
}

// Intento “amable” de avisarle al theme que el carrito cambió (sin romper nada)
function emitCartEvents(cart) {
  const events = ['cart:updated', 'cart:refresh', 'theme:cart:updated', 'theme:cart:refresh'];
  events.forEach((name) => {
    document.dispatchEvent(new CustomEvent(name, { detail: { cart } }));
  });
}
function ctUnlockScrollIfLocked() {
  try {
    if (document.body?.style?.overflow === 'hidden') document.body.style.overflow = '';
    if (document.documentElement?.style?.overflow === 'hidden') document.documentElement.style.overflow = '';
  } catch (e) {}
}
function updateCartCountBadge(cart) {
  const count = Number(cart?.item_count || 0);

  const candidates = [
  '#cart-icon-bubble',
  '#cart-icon-bubble .header__cart-count-number',
  '.header__cart-count-number',
  '[data-cart-count]',
  '.cart-count',
  '.header__cart-count',
  '.cart-link__count',
  '.site-header__cart-count',
  'a[href="/cart"] .count',
  'a[href="/cart"] [class*="count"]'
];

  // Encuentra nodos que existan
  const nodes = [];
  candidates.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => nodes.push(el));
  });

  // Si el theme usa un web component tipo <cart-icon-bubble> a veces el número vive adentro:
  // actualizamos texto del elemento o el primer hijo que sea “badge-like”.
  nodes.forEach((el) => {
    // Si tiene un hijo con número, úsalo; si no, usa el mismo elemento
    const badge =
      el.querySelector?.('[data-cart-count], .cart-count, .count, .badge') || el;

    // Evita romper elementos que no son texto
    if (badge) {
      badge.textContent = String(count);
    }

    // Oculta si es 0 (si tu theme lo maneja distinto, quita esto)
    if (count <= 0) {
      el.setAttribute('data-empty', 'true');
    } else {
      el.removeAttribute('data-empty');
    }
  });
}
let ctDrawerRefreshTimer = null;

function refreshCanopyCartDrawerNow(options = {}) {
  const openDrawer = options.openDrawer === true;
  const cartDrawer =
    document.querySelector('cart-drawer') ||
    document.querySelector('#cart-drawer');

  if (cartDrawer && typeof cartDrawer.refreshCartDrawer === 'function') {
    cartDrawer.refreshCartDrawer(true);

    if (openDrawer && typeof cartDrawer.open === 'function') {
      setTimeout(() => cartDrawer.open(), 80);
    }

    return true;
  }

  return false;
}

function scheduleCanopyCartDrawerRefresh(delay = 600) {
  if (ctDrawerRefreshTimer) {
    window.clearTimeout(ctDrawerRefreshTimer);
  }

  ctDrawerRefreshTimer = window.setTimeout(() => {
    ctDrawerRefreshTimer = null;
    refreshCanopyCartDrawerNow({ openDrawer: false });
  }, delay);
}
let ctCartUiRefreshTimer = null;

function refreshThemeCartUI() {
  if (ctCartUiRefreshTimer) return;

  ctCartUiRefreshTimer = window.setTimeout(async () => {
    ctCartUiRefreshTimer = null;
    // ✅ FIX: si alguna app dejó el scroll bloqueado (body overflow hidden), lo liberamos
try {
  if (document.body && document.body.style && document.body.style.overflow === 'hidden') {
    document.body.style.overflow = '';
  }
  if (document.documentElement && document.documentElement.style && document.documentElement.style.overflow === 'hidden') {
    document.documentElement.style.overflow = '';
  }
} catch (e) {}

    const sections = ['cart-drawer', 'cart-icon-bubble'];

    try {
      const res = await fetch(`/?sections=${sections.join(',')}`, { credentials: 'same-origin' });
      if (!res.ok) return;

      const data = await res.json();

      if (data['cart-icon-bubble']) {
  const bubble =
    document.querySelector('#cart-icon-bubble') ||
    document.querySelector('#cart-icon-bubble .header__cart-count-number') ||
    document.querySelector('.header__cart-count-number') ||
    document.querySelector('[data-cart-count]') ||
    document.querySelector('.cart-count');

  // Si encontramos el contenedor real (#cart-icon-bubble), reemplazamos ese.
  // Si encontramos solo el numerito, reemplazamos el #cart-icon-bubble más cercano.
  const bubbleHost =
    bubble?.id === 'cart-icon-bubble'
      ? bubble
      : bubble?.closest?.('#cart-icon-bubble') || document.querySelector('#cart-icon-bubble');

  if (bubbleHost) bubbleHost.outerHTML = data['cart-icon-bubble'];
}

      if (data['cart-drawer']) {
  const cartDrawer =
    document.querySelector('cart-drawer') ||
    document.querySelector('#cart-drawer');

  if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
    cartDrawer.renderContents({ sections: data }, false);
  } else {
    scheduleCanopyCartDrawerRefresh(300);
  }

  document.dispatchEvent(new CustomEvent('cart:updated'));
  document.dispatchEvent(new CustomEvent('cart:refresh'));
  document.dispatchEvent(new CustomEvent('theme:cart:updated'));
  document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
}
    } catch (e) {}
  }, 600);
}
function refreshCtGridFromCart() {
  try {
    initAllGridCartSync();
    initPdpCartSync();
  } catch (e) {
    console.warn('[CT PACKS] No se pudo refrescar grid/PDP desde carrito:', e);
  }
}

function reinitCartItemsAfterDrawerChange() {
  setTimeout(() => {
    document.querySelectorAll('cart-items').forEach((cartItems) => {
      if (typeof cartItems.init === 'function') {
        cartItems.init();
      }
    });
  }, 50);
}
function wireQtyInputTyping(nodes) {
  if (!nodes.qtyEl || nodes.qtyEl.tagName !== 'INPUT') return;
  if (!Number.isFinite(nodes.variantId) || nodes.variantId <= 0) return;

  const input = nodes.qtyEl;
  if (input.dataset.ctTypingBound === 'true') return;
  input.dataset.ctTypingBound = 'true';

  input.setAttribute('inputmode', 'numeric');
  input.setAttribute('pattern', '[0-9]*');

  input.addEventListener('input', () => {
    const cleaned = String(input.value || '').replace(/[^\d]/g, '');
    if (input.value !== cleaned) input.value = cleaned;
  });

  let ctTypingTimer = null;

  const scheduleCommit = (ms = 450) => {
    if (ctTypingTimer) clearTimeout(ctTypingTimer);
    ctTypingTimer = setTimeout(() => {
      commit();
    }, ms);
  };

  input.addEventListener('keyup', () => {
    const v = String(input.value || '').trim();
    if (v === '') {
      scheduleCommit(350);
      return;
    }
    if (/^\d+$/.test(v)) {
      scheduleCommit(450);
    }
  });

  const clampQty = (n) => {
    if (!Number.isFinite(n)) return 0;
    return Math.max(0, Math.min(9999, Math.floor(n)));
  };

  const commit = async () => {
    clearCardMessage(nodes);

    const typed = readQtyEl(input);
    let targetQty = clampQty(typed);

    const stepperEl = nodes.stepperWrap?.querySelector('[data-ct-stepper]');
    const currentQty = Number(
      stepperEl?.getAttribute('data-ct-qty') || readQtyEl(input) || 0
    );

    try {
      const maxQty = await getMaxAllowedQtyForVariant(nodes);
      const safeQty = clampQtyToAvailableStock(targetQty, maxQty);

      if (Number.isFinite(currentQty) && currentQty === safeQty) {
        input.value = String(safeQty);
        updateStepperLimitState(nodes, safeQty, maxQty);
        return;
      }

      if (targetQty > safeQty) {
  showStockAdjustedMessage(nodes, targetQty, safeQty, { context: 'typing' });
}

      targetQty = safeQty;

      updateStepperLimitState(nodes, targetQty, maxQty);
      input.value = String(targetQty);
      setStepperUI(nodes, targetQty);
      if (targetQty <= 0 && nodes.applyBtn) nodes.applyBtn.hidden = true;

      const cart = await cartChange(nodes.variantId, targetQty);
      const map = buildQtyMap(cart);
      const realQty = getQtyFromMap(map, nodes.variantId);

      updateStepperLimitState(nodes, realQty, maxQty);
      setStepperUI(nodes, realQty);
      input.value = String(realQty);

      updateCardUnitPrice(nodes, realQty);
      updateCardStrikePrice(nodes, realQty);
      emitCartEvents(cart);
      updateCartCountBadge(cart);
      scheduleCanopyCartDrawerRefresh(600);
      ctUnlockScrollIfLocked();

      if (realQty > 0) {
        syncPackToQty(nodes, realQty);
        if (nodes.packRoot) updateMetaForQty(nodes.packRoot, realQty);
      } else {
        if (nodes.packRoot) updateMetaForQty(nodes.packRoot, 0);
        if (nodes.applyBtn) nodes.applyBtn.hidden = true;
      }

      hideNativeCardPrice(nodes);
    } catch (err) {
      try {
        const cart = await fetchCart();
        const map = buildQtyMap(cart);
        const realQty = getQtyFromMap(map, nodes.variantId);
        const maxQty = await getMaxAllowedQtyForVariant(nodes);

        updateStepperLimitState(nodes, realQty, maxQty);
        setStepperUI(nodes, realQty);
        input.value = String(realQty);

        updateCardUnitPrice(nodes, realQty);
        updateCardStrikePrice(nodes, realQty);

        if (realQty > 0) {
          syncPackToQty(nodes, realQty);
          if (nodes.packRoot) updateMetaForQty(nodes.packRoot, realQty);
        } else {
          if (nodes.applyBtn) nodes.applyBtn.hidden = true;
        }

        hideNativeCardPrice(nodes);
        ctUnlockScrollIfLocked();
      } catch (e) {}
    }
  };

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      input.blur();
    }
  });

  input.addEventListener('input', () => {
    scheduleCommit();
  });

  input.addEventListener('paste', () => {
    scheduleCommit();
  });

  input.addEventListener('blur', () => {
    commit();
  });

  input.addEventListener('focus', () => {
    try { input.select(); } catch (e) {}
  });
}
// ===== Debounce commit para stepper +/- (evita 20 requests por 20 clicks) =====
const CT_STEPPER_COMMIT_DELAY = 300;
const ctStepperCommitState = new WeakMap(); // key: nodes.stepperWrap

function scheduleStepperCommit(nodes, targetQty) {
  if (!nodes?.stepperWrap) return;

  let st = ctStepperCommitState.get(nodes.stepperWrap);
  if (!st) {
    st = { timer: null, queuedQty: 0, promise: Promise.resolve() };
    ctStepperCommitState.set(nodes.stepperWrap, st);
  }

  st.queuedQty = Number(targetQty || 0);

  if (st.timer) window.clearTimeout(st.timer);

  st.timer = window.setTimeout(() => {
    st.timer = null;

    st.promise = st.promise
      .then(async () => {
        const maxQty = await getMaxAllowedQtyForVariant(nodes);
        const safeQty = clampQtyToAvailableStock(st.queuedQty, maxQty);

        const cart = await cartChange(nodes.variantId, safeQty);
        const map = buildQtyMap(cart);
        const realQty = getQtyFromMap(map, nodes.variantId);

        updateStepperLimitState(nodes, realQty, maxQty);
        setStepperUI(nodes, realQty);
        updateCardUnitPrice(nodes, realQty);
        updateCardStrikePrice(nodes, realQty);
        hideNativeCardPrice(nodes);

        emitCartEvents(cart);
        updateCartCountBadge(cart);

        if (realQty > 0) {
          syncPackToQty(nodes, realQty);
          if (nodes.packRoot) updateMetaForQty(nodes.packRoot, realQty);
          if (nodes.applyBtn) nodes.applyBtn.hidden = true;
        } else {
          if (nodes.packRoot) updateMetaForQty(nodes.packRoot, 0);
          if (nodes.applyBtn) nodes.applyBtn.hidden = true;
        }

        scheduleCanopyCartDrawerRefresh(600);
        ctUnlockScrollIfLocked();
      })
      .catch(async () => {
        try {
          const cart = await fetchCart();
          const map = buildQtyMap(cart);
          const realQty = getQtyFromMap(map, nodes.variantId);
          const maxQty = await getMaxAllowedQtyForVariant(nodes);

          updateStepperLimitState(nodes, realQty, maxQty);
          setStepperUI(nodes, realQty);
          updateCardUnitPrice(nodes, realQty);
          updateCardStrikePrice(nodes, realQty);

          if (realQty > 0) {
            syncPackToQty(nodes, realQty);
            if (nodes.packRoot) updateMetaForQty(nodes.packRoot, realQty);
          } else {
            if (nodes.packRoot) updateMetaForQty(nodes.packRoot, 0);
            if (nodes.applyBtn) nodes.applyBtn.hidden = true;
          }

          hideNativeCardPrice(nodes);
          ctUnlockScrollIfLocked();
        } catch (e) {}
      });
  }, CT_STEPPER_COMMIT_DELAY);
}

function wireStepper(nodes) {
  if (!nodes.btnPlus || !nodes.btnMinus || !nodes.qtyEl) return;
  if (!Number.isFinite(nodes.variantId) || nodes.variantId <= 0) return;
  if (nodes.stepperWrap && nodes.stepperWrap.dataset.ctBound === 'true') return;
  if (nodes.stepperWrap) nodes.stepperWrap.dataset.ctBound = 'true';

  nodes.btnPlus.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    clearCardMessage(nodes);

    const currentQty = readQtyEl(nodes.qtyEl);
    const maxQty = await getMaxAllowedQtyForVariant(nodes);

    updateStepperLimitState(nodes, currentQty, maxQty);

    if (currentQty >= maxQty) {
  showStockAdjustedMessage(nodes, currentQty + 1, currentQty, { context: 'stepper-max' });
  setStepperUI(nodes, currentQty);
  if (nodes.qtyEl.tagName === 'INPUT') {
    nodes.qtyEl.value = String(currentQty);
  }
  return;
}

    const nextQty = clampQtyToAvailableStock(currentQty + 1, maxQty);

    updateStepperLimitState(nodes, nextQty, maxQty);
    setStepperUI(nodes, nextQty);
    updateCardUnitPrice(nodes, nextQty);
    updateCardStrikePrice(nodes, nextQty);
    hideNativeCardPrice(nodes);
    scheduleStepperCommit(nodes, nextQty);
  });

  nodes.btnMinus.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    clearCardMessage(nodes);

    const currentQty = readQtyEl(nodes.qtyEl);
    const nextQty = Math.max(0, currentQty - 1);
    const maxQty = await getMaxAllowedQtyForVariant(nodes);

    updateStepperLimitState(nodes, nextQty, maxQty);
    setStepperUI(nodes, nextQty);
    updateCardUnitPrice(nodes, nextQty);
    updateCardStrikePrice(nodes, nextQty);
    hideNativeCardPrice(nodes);
    scheduleStepperCommit(nodes, nextQty);
  });

  if (nodes.applyBtn && nodes.packRoot && nodes.packSelect) {
    nodes.applyBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      clearCardMessage(nodes);

      const packs = nodes.packRoot.__ctPacks || [];
      const idx = Number(nodes.packSelect.value);
      const pack = packs[idx] || packs[0];
      let targetQty = Number(pack?.qty || 0);

      if (targetQty <= 0) return;

      try {
        const maxQty = await getMaxAllowedQtyForVariant(nodes);
        const safeQty = clampQtyToAvailableStock(targetQty, maxQty);

        if (targetQty > safeQty) {
  showStockAdjustedMessage(nodes, targetQty, safeQty, { context: 'apply-pack' });
}

        targetQty = safeQty;

        updateStepperLimitState(nodes, targetQty, maxQty);
        setStepperUI(nodes, targetQty);

        const cart = await cartChange(nodes.variantId, targetQty);
        const map = buildQtyMap(cart);
        const realQty = getQtyFromMap(map, nodes.variantId);

        updateStepperLimitState(nodes, realQty, maxQty);
        setStepperUI(nodes, realQty);
        updateCardUnitPrice(nodes, realQty);
        updateCardStrikePrice(nodes, realQty);
        hideNativeCardPrice(nodes);

        emitCartEvents(cart);
        updateCartCountBadge(cart);
        scheduleCanopyCartDrawerRefresh(600);
        ctUnlockScrollIfLocked();

        nodes.applyBtn.hidden = true;
        updateMetaForQty(nodes.packRoot, realQty);

        const packsNow = nodes.packRoot.__ctPacks || [];
        const idxNow = getPackIdxForQty(packsNow, realQty);
        setActiveTab(nodes.packRoot, (packsNow[idxNow] || packsNow[0]).qty);
      } catch (err) {
        showCardMessage(nodes, 'Hubo un problema al actualizar la cantidad.', {
  type: 'error',
  autoHideMs: 5000
});

        const cart = await fetchCart();
        const map = buildQtyMap(cart);
        const realQty = getQtyFromMap(map, nodes.variantId);
        const maxQty = await getMaxAllowedQtyForVariant(nodes);

        updateStepperLimitState(nodes, realQty, maxQty);
        setStepperUI(nodes, realQty);
        ctUnlockScrollIfLocked();
      }
    });
  }
}
function wireAtcRefresh(nodes) {
  const atcBtn = nodes.atcWrap?.querySelector('button[name="add"]');
  if (!atcBtn || !nodes.variantId) return;
  if (atcBtn.dataset.ctBound === 'true') return;
  atcBtn.dataset.ctBound = 'true';

  atcBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    if (atcBtn.dataset.ctBusy === 'true') return;
    atcBtn.dataset.ctBusy = 'true';

    clearCardMessage(nodes);

    try {
      let qty = Number(nodes.qtyInput?.value || 0);
      if (!qty || qty <= 0) {
        const packs = nodes.packRoot?.__ctPacks || [];
        const idx = Number(nodes.packSelect?.value || 0);
        qty = Number((packs[idx] || packs[0])?.qty || 1);
      }

      const maxQty = await getMaxAllowedQtyForVariant(nodes);
      const safeQty = clampQtyToAvailableStock(qty, maxQty);

      if (qty > safeQty) {
  showStockAdjustedMessage(nodes, qty, safeQty, { context: 'add' });
}

      if (safeQty <= 0) {
        showCardMessage(nodes, 'Sin stock disponible.', {
  type: 'error',
  autoHideMs: 5000
});
        updateStepperLimitState(nodes, 0, maxQty);
        return;
      }

      const cart = await cartAdd(nodes.variantId, safeQty);
      const map = buildQtyMap(cart);
      const realQty = getQtyFromMap(map, nodes.variantId) || safeQty;

      updateStepperLimitState(nodes, realQty, maxQty);
      setStepperUI(nodes, realQty);
      updateCardUnitPrice(nodes, realQty);
      updateCardStrikePrice(nodes, realQty);
      hideNativeCardPrice(nodes);

      emitCartEvents(cart);
      updateCartCountBadge(cart);
      scheduleCanopyCartDrawerRefresh(600);
      ctUnlockScrollIfLocked();

      syncPackToQty(nodes, realQty);
      if (nodes.applyBtn) nodes.applyBtn.hidden = true;
    } catch (err) {
      showCardMessage(nodes, 'Hubo un problema al agregar. Intenta de nuevo.', {
  type: 'error',
  autoHideMs: 5000
});
      console.warn('[CT ATC] fallo cartAdd:', err);
    } finally {
      atcBtn.dataset.ctBusy = 'false';
    }
  });
}

async function initAllGridCartSync() {
  const forms = document.querySelectorAll(SELECTOR_ALL_GRID_FORMS);
  if (!forms.length) return;

  let cart;
  try {
    cart = await fetchCart();
  } catch (e) {
    return;
  }
  const map = buildQtyMap(cart);

  forms.forEach((pf) => {
    const nodes = findCardNodes(pf);
    if (!nodes.variantId) return;

    const qty = getQtyFromMap(map, nodes.variantId);
setStepperUI(nodes, qty);

if (qty > 0) {
  // Si ya hay qty en carrito: sincroniza pack y pinta promo+strike
  syncPackToQty(nodes, qty);
  updateCardUnitPrice(nodes, qty);
  updateCardStrikePrice(nodes, qty);

  // ✅ Ahora sí: como unit CT ya está visible, ocultamos el precio nativo
  hideNativeCardPrice(nodes);
} else {
  // Si NO hay qty en carrito, NO escondas el precio nativo
  // (deja que se vea el precio normal al cargar)

  // Oculta nuestros slots CT al cargar en 0 (para que no “tapen” nada)
  updateCardUnitPrice(nodes, 0);
  updateCardStrikePrice(nodes, 0);

  // ⚠️ NO llames hideNativeCardPrice aquí
}

    wireApplyPackBehavior(nodes);
    wireStepper(nodes);
    wireQtyInputTyping(nodes);
    wireAtcRefresh(nodes);
  });
}
async function initPdpCartSync() {
  const forms = document.querySelectorAll(SELECTOR_PDP_FORMS);
  if (!forms.length) return;

  let cart;
  try {
    cart = await fetchCart();
  } catch (e) {
    return;
  }

  const map = buildQtyMap(cart);

  forms.forEach((pf) => {
    const nodes = findCardNodes(pf);
    if (!nodes.variantId) return;

    const qty = getQtyFromMap(map, nodes.variantId);

    // UI base
    setStepperUI(nodes, qty);

    if (qty > 0) {
      // 🔁 Persistencia total en refresh
      syncPackToQty(nodes, qty);
      updateCardUnitPrice(nodes, qty);
      updateCardStrikePrice(nodes, qty);
      hideNativeCardPrice(nodes);
    } else {
      // PDP sin carrito → deja precio nativo
      updateCardUnitPrice(nodes, 0);
      updateCardStrikePrice(nodes, 0);
    }

    wireApplyPackBehavior(nodes);
    wireStepper(nodes);
    wireQtyInputTyping(nodes);
    wireAtcRefresh(nodes);
  });
}

  function safeParseJson(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  }

  function moneyFromCents(cents, moneyFormat) {
    // Shopify money_format usually expects a string like "{{amount}}"
    // We'll do a simple formatter based on cents and then replace amount patterns.
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.round(cents / 100).toString();

    // Handle common Shopify placeholders:
    // {{amount}}, {{amount_no_decimals}}
    return (moneyFormat || '{{amount}}')
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', amountNoDecimals);
  }

  function normalizePacks(packs) {
    if (!Array.isArray(packs)) return [];
    return packs
      .map(p => ({
        qty: Number(p.qty),
        label: (p.label ?? '').toString(),
        discount: Number(p.discount || 0)
      }))
      .filter(p => Number.isFinite(p.qty) && p.qty > 0)
      .sort((a, b) => a.qty - b.qty);
  }

  function targetPriceToCents(value, basePriceCents) {
  const price = Number(value || 0);

  if (!Number.isFinite(price) || price <= 0) {
    return basePriceCents;
  }

  return Math.round(price * 100);
}

function computePricing(basePriceCents, qty, targetPrice) {
  const q = Number(qty || 0);
  const subtotal = basePriceCents * q;
  const targetUnit = targetPriceToCents(targetPrice, basePriceCents);
  const discountedTotal = targetUnit * q;
  const unit = targetUnit;
  const savings = Math.max(0, subtotal - discountedTotal);

  return { subtotal, discountedTotal, unit, savings };
}
  function applyColorsIfEnabled(root) {
    const enabled = root.dataset.ctEnableColors === 'true';
    if (!enabled) return;

    const total = root.dataset.ctColorTotal;
    const unit = root.dataset.ctColorUnit;
    const savings = root.dataset.ctColorSavings;

    if (total) root.style.setProperty('--ct-pack-total', total);
    if (unit) root.style.setProperty('--ct-pack-unit', unit);
    if (savings) root.style.setProperty('--ct-pack-savings', savings);
  }

  function findProductForm(root) {
    // We inserted ct-pack inside the <form>, so closest('form') should work.
    // If theme structure changes, we fallback to nearest product-form container.
    return root.closest('form') || root.closest('product-form')?.querySelector('form') || null;
  }

  function getOrCreateQuantityInput(form) {
    if (!form) return null;

    // Prefer existing quantity input if present
    let qtyInput =
      form.querySelector('input[name="quantity"]') ||
      form.querySelector('input[data-quantity-input]');

    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      form.appendChild(qtyInput);
    }

    return qtyInput;
  }

  function ensureVariantIdEnabled(form) {
    // In your current file, the variant input is disabled.
    // We must enable it or create a correct hidden input.
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.disabled = false;
      return;
    }
  }

  function updateMetaUI(root, pack, basePriceCents) {
    const moneyFormat = root.dataset.ctMoneyFormat || '{{amount}}';
    const showTotal = root.dataset.ctShowTotal === 'true';
    const showUnit = root.dataset.ctShowUnit === 'true';
    const showSavings = root.dataset.ctShowSavings === 'true';

    const meta = root.querySelector('[data-ct-pack-meta]');
    const elTotal = root.querySelector('[data-ct-pack-total]');
    const elUnit = root.querySelector('[data-ct-pack-unit]');
    const elSavings = root.querySelector('[data-ct-pack-savings]');

    if (!meta || !elTotal || !elUnit || !elSavings) return;

    const { discountedTotal, unit, savings } = computePricing(basePriceCents, pack.qty, pack.discount);

    let hasAny = false;

    if (showTotal) {
      elTotal.textContent = `Total: ${moneyFromCents(discountedTotal, moneyFormat)}`;
      elTotal.hidden = false;
      hasAny = true;
    } else {
      elTotal.hidden = true;
    }

    if (showUnit) {
      elUnit.textContent = `Unitario: ${moneyFromCents(unit, moneyFormat)}`;
      elUnit.hidden = false;
      hasAny = true;
    } else {
      elUnit.hidden = true;
    }

    if (showSavings) {
      elSavings.textContent = savings > 0
        ? `Ahorro: ${moneyFromCents(savings, moneyFormat)}`
        : `Ahorro: ${moneyFromCents(0, moneyFormat)}`;
      elSavings.hidden = false;
      hasAny = true;
    } else {
      elSavings.hidden = true;
    }

    meta.hidden = !hasAny;
  }
  function renderTabsIfNeeded(root, packs, selectEl) {
    const tabsWrap = root.querySelector('.ct-pack__tabs');
    if (!tabsWrap) return;

    tabsWrap.innerHTML = '';

    packs.forEach((p, idx) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ct-pack__tab';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', 'false');
      btn.dataset.ctPackTab = String(p.qty);
      btn.textContent = (p.label && p.label.trim().length) ? p.label : `Pack ${p.qty}`;

      btn.addEventListener('click', () => {
        // select es la "fuente de verdad"
        selectEl.value = String(idx);
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      });

      tabsWrap.appendChild(btn);
    });
  }

  function initPackBlock(root) {
  const select = root.querySelector('[data-ct-pack-select]');
  if (!select) return;

  const packsStr = root.dataset.ctPackJson || '[]';
  const packsRaw = safeParseJson(packsStr);
  const packs = normalizePacks(packsRaw);
  if (packs.length === 0) return;

  applyColorsIfEnabled(root);

  // Fill select options (siempre reconstruye)
  select.innerHTML = '';
  packs.forEach((p, idx) => {
    const opt = document.createElement('option');
    opt.value = String(idx);
    opt.textContent = (p.label && p.label.trim().length)
      ? p.label
      : `Pack ${p.qty}`;
    select.appendChild(opt);
  });

  // Si PDP usa tabs, renderiza tabs (select sigue siendo “source of truth”)
  renderTabsIfNeeded(root, packs, select);

  const basePriceCents = Number(root.dataset.ctBasePrice || 0);

  // Guardamos referencia para sincronizar con stepper/cart
  root.__ctPacks = packs;
  root.__ctBasePriceCents = basePriceCents;

  const form = findProductForm(root);
  if (form) ensureVariantIdEnabled(form);

  const qtyInput = getOrCreateQuantityInput(form);

  // Default selection: first pack
  const defaultIdx = 0;
  select.value = String(defaultIdx);

  let isFirstRun = true; // evita ocultar/pintar promo en el primer render automático

  const applySelection = () => {
    const idx = Number(select.value || 0);
    const pack = packs[idx] || packs[0];

    // Update hidden quantity in form
    if (qtyInput) qtyInput.value = String(pack.qty);

    // Update meta display
    updateMetaUI(root, pack, basePriceCents);

    // SOLO después de interacción del usuario: pintar promo/strike + ocultar nativo
    const pf = root.closest('product-form');
    if (pf) {
      const cardNodes = findCardNodes(pf);
      if (!isFirstRun) {
        updateCardUnitPrice(cardNodes, Number(pack.qty));
        updateCardStrikePrice(cardNodes, Number(pack.qty));
        hideNativeCardPrice(cardNodes);
      }
    }

    // Mark active tab (si existe)
    const tabs = root.querySelectorAll('.ct-pack__tab');
    if (tabs.length) {
      tabs.forEach((t) => {
        const tabQty = Number(t.dataset.ctPackTab || 0);
        const isSelected = tabQty === Number(pack.qty);
        t.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    isFirstRun = false;
  };

  select.addEventListener('change', applySelection);
  applySelection();
}

  function initAll() {
  document.querySelectorAll(SELECTOR_PACK).forEach(initPackBlock);

  initAllGridCartSync(); // grid
  initPdpCartSync();     // pdp
}

// Init on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

// Re-init when Shopify reloads a section
document.addEventListener('shopify:section:load', initAll);

// Fallback (algunos themes terminan de pintar después)
window.addEventListener('load', () => {
  initAll();
  setTimeout(initAll, 300);
  setTimeout(initAll, 1000);
});
window.addEventListener('pageshow', () => {
  initAll();
  setTimeout(initAll, 150);
  setTimeout(initAll, 600);
});
// CT FIX: sincroniza grid y drawer cuando el drawer se abre/cierra.
// Esto evita que el drawer quede con listeners viejos y que el grid muestre cantidades pasadas.
document.addEventListener('click', (event) => {
  const openDrawerTrigger = event.target.closest(
    'a[href="/cart"], button[name="cart"], [aria-controls="cart-drawer"], [data-cart-drawer-open], .js-cart-drawer-open'
  );

  if (openDrawerTrigger) {
  if (ctDrawerRefreshTimer) {
    window.clearTimeout(ctDrawerRefreshTimer);
    ctDrawerRefreshTimer = null;
  }

  setTimeout(() => {
    refreshCanopyCartDrawerNow({ openDrawer: false });
    reinitCartItemsAfterDrawerChange();
  }, 80);
}

  const closeDrawerTrigger = event.target.closest(
    '[aria-controls="cart-drawer"][aria-expanded="true"], [data-cart-drawer-close], .drawer__close, .js-close-drawer, .js-close'
  );

  if (closeDrawerTrigger) {
    setTimeout(() => {
      refreshCtGridFromCart();
    }, 250);
  }
});
// CT FIX: cuando Canopy cambia cantidades dentro del drawer,
// refrescamos el grid para que no se quede con cantidades viejas.
document.addEventListener('on:line-item:change', () => {
  setTimeout(() => {
    refreshCtGridFromCart();
  }, 300);
});

// ✅ Init también cuando “Cargar más” inserta productos por AJAX (infinite scroll)
let ctPacksMoTimer = null;
const scheduleInitAll = () => {
  if (ctPacksMoTimer) return;
  ctPacksMoTimer = setTimeout(() => {
    ctPacksMoTimer = null;
    initAll();
  }, 120);
};

const ctPacksObserver = new MutationObserver((mutations) => {
  for (const m of mutations) {
    if (!m.addedNodes || !m.addedNodes.length) continue;

    for (const node of m.addedNodes) {
      if (!(node instanceof Element)) continue;

      // Si el nodo insertado ES un pack o contiene packs, re-init
      if (node.matches?.(SELECTOR_PACK) || node.querySelector?.(SELECTOR_PACK)) {
        scheduleInitAll();
        return;
      }
    }
  }
});

// Observa todo el documento; es lo más robusto si el theme no expone el contenedor exacto
const ctObserveRoot =
  document.querySelector('#MainContent') ||
  document.querySelector('main') ||
  document.body;

ctPacksObserver.observe(ctObserveRoot, { childList: true, subtree: true });

})();

